// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames/bind';

import styles from './styles';
import {
  BANK_TRANSFER,
  PAYPAL,
  VOUCHER,
  CHARITY,
} from '../../config/constants';
import paypal from '../../images/paypal.png';


class PaymentTypeLabel extends React.Component {
  state = {
    isRenderEditFields: false,
  };

  onClickEdit = () => {
    this.setState(prevState => (
      { isRenderEditFields: !prevState.isRenderEditFields }
    ));
  }

  render() {
    const {
      type,
      text,
      classes,
      selectedPaymentType,
      paymentIndex,
      showEditButton,
      renderPaymentTypeInfo,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.paymentTypeContainer}>
          {paymentIndex
            && (
              <div
                className={classNames(classes.paymentSelectIndex,
                  selectedPaymentType === type ? classes.onClickPaymentSelectIndex : null)}
                role="button"
                aria-hidden="true"
                onClick={() => this.props.setPaymentType(type)}
              />)}

          {[BANK_TRANSFER, VOUCHER, CHARITY].includes(type)
            && (
              <span
                className={classNames(classes.paymentMethodText, classes.paymentMethodTextColor)}
              >
                {text}
              </span>)}
          {type === PAYPAL
            && <img
              className={classes.paypalImage}
              src={paypal}
              alt={'paypal'}
            />}

          {showEditButton
            && (
              <span
                className={classes.editText}
                role="button"
                aria-hidden="true"
                onClick={() => this.onClickEdit()}
              >
                Edit
              </span>)}
        </div>

        {(!showEditButton || this.state.isRenderEditFields) && renderPaymentTypeInfo}
      </div>
    );
  }
}

PaymentTypeLabel.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.number,
  text: PropTypes.string,
  selectedPaymentType: PropTypes.number,
  setPaymentType: PropTypes.func,
  paymentIndex: PropTypes.bool,
  showEditButton: PropTypes.bool,
  renderPaymentTypeInfo: PropTypes.element,
};

PaymentTypeLabel.defaultProps = {
  classes: {},
  type: 0,
  text: '',
  selectedPaymentType: BANK_TRANSFER,
  setPaymentType: () => { },
  paymentIndex: true,
  showEditButton: true,
  renderPaymentTypeInfo: null,
};

export default withStyles(styles)(PaymentTypeLabel);
